import axios from 'axios'
import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'

const authStore = (set: any) => ({
  userProfile: {},
  userInfo: undefined,
  openLogginDetails: {},

  setCurrentUser: (user: any) =>
    set((state: any) => ({
      userInfo: user,
    })),

  setOpenLogginDetails: (data: any) =>
    set((state: any) => ({
      openLogginDetails: data,
    })),

  getCurrentUser: () => {
    const uid = localStorage.getItem('uid')
    if (uid != null) {
      axios
        .post(
          'https://us-central1-test-69192.cloudfunctions.net/profile/getUserById',
          {
            userId: localStorage.getItem('uid'),
            otherUser: false,
          }
        )
        .then((res: any) => {
          console.log('getting data')
          set((state: any) => ({
            userProfile: res.data.data.user_details,
          }))
        })
        .catch((e: any) => {
          // console.log(e);
        })
    }
  },
})

const useAuthStore = create(
  devtools(
    persist(authStore, {
      name: 'auth',
    })
  )
  // authStore
)

export default useAuthStore
